<template>
  <transition
    appear
    name="custom-classes-transition"
    enter-active-class="animated fadeIn faster"
    leave-active-class="animated fadeOut faster"
  >
    <popup v-if="show">
      <div class="ui-message-tips" @click="onClose">
        <img
          class="share"
          @click.stop
          :src="`${$cdn}images/img_scene_share@3x.png`"
          alt
        /> 
      </div>
    </popup>
  </transition>
</template>
<script>
import Popup from "./popup";
import browser from "@/utils/browser";

export default {
  name: "ui-tips",
  components: {
    Popup,
  },
  data() {
    return {
      show: false,
      duration: 1000,
      isMobile: browser.mobile,
      content: "",
      type: "intro",
      map:'',
      marker:''
    };
  },
  methods: {
    onClose() {
      setTimeout(() => {
        this.show = false;
        document.body.removeChild(this.$el);
        this.$destroy();
      }, 0);
    },
  },
  mounted() {
    
  },
};
</script>
<style lang="less" scoped>
.ui-message-tips {
  position: relative;
  width: 100%;
  height: 100%;
  background-color:rgba(0,0,0,0.8);
  .share{
    position: absolute;
    top: 0;
    right: 20px;
    width: 40%;
  }

}
@media screen and (max-width: 500px) {
 
}
</style>